// Added by Sejune Oh on 2020-07-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Skeleton as MaterialSkeleton,
    SkeletonProps as MaterialSkeletonProps
} from '@material-ui/lab'

export const Skeleton: FC<MaterialSkeletonProps> = ({ ...props }) => {
    return <MaterialSkeleton  {...props} />
}
